import React, { useEffect, useMemo, useState } from 'react';
import '../CSS/DesafiosChallenges.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPuzzlePiece, faUsers, faClock } from '@fortawesome/free-solid-svg-icons';

/*Deixar comentado até haver um novo banner */
/*import SummerBanner from './../Components/Banner/SummerPromotion';*/

/*Imagens: manter os nomes 'backgroundImage' e 'cardImage'. 'backgroundImageMobile' é para versão mobile*/
/*import backgroundImage from '../Images/Imagem3.png';*/
/*import backgroundImage from '../Images/fundoNatal.png';*/
import backgroundImage from '../Images/fundoUniversoTempo.png';
/*import backgroundImageMobile from '../Images/fundoNatalCard.png';*/
import backgroundImageMobile from '../Images/cardMobileTempo.png';
/*import cardImage from '../Images/card.png';*/
import cardImage from '../Images/cardUniversoTempo.png';
/*import cardImage from '../Images/cardNatal.png';*/

const Desafios = () => {
    
    //List of current challenges
    //Each element has a title, description, level, duration, and participants
    const [challenges, setChallenges] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [poppedBalloons, setPoppedBalloons] = useState({});

    useEffect(() => {
        //fetch available challenges
        const fetchChallenges = async () => {
            try {
                const response = await fetch('https://personal-d4yby5if.outsystemscloud.com/Booking_API/rest/Challenges/v3/Get');
                if (!response.ok) {
                    throw new Error('Failed to fetch challenges');
                }
                const data = await response.json();
        
                setChallenges(data);
                setHasError(false);
            } catch (error) {
                console.error('Error fetching challenges:');
                setHasError(true);
            } finally {
                setIsLoading(false);
            }
        };

        fetchChallenges();
    
    }, []);

    const handleClick = (desafioId) => {
        localStorage.setItem('selectedChallenge', desafioId);
    };

    const handlePopBalloon = (id) => {
        setPoppedBalloons((prev) => ({ ...prev, [id]: true }));
    };

    const sortedChallenges = useMemo(() => {
        if (!Array.isArray(challenges)) return [];
        return [...challenges].sort((a, b) => (a?.Order ?? 0) - (b?.Order ?? 0));
    }, [challenges]);

    const LevelDots = ({ level = 1 }) => {
        const safeLevel = Math.max(1, Math.min(5, Number(level) || 1));
        return (
            <div
                className="er-level"
                aria-label={`Difficulty ${safeLevel} out of 5`}
                title={`Difficulty: ${safeLevel}/5`}
            >
                {Array.from({ length: 5 }).map((_, idx) => (
                    <FontAwesomeIcon
                        key={idx}
                        icon={faPuzzlePiece}
                        className={`er-levelDot ${idx < safeLevel ? 'is-on' : 'is-off'}`}
                    />
                ))}
            </div>
        );
    };

    const ChallengeCard = ({ challenge }) => {
        const [showPrices, setShowPrices] = useState(false);
        const isActive = challenge?.IsActive === true;

        return (
            <article className={`er-chCard ${isActive ? '' : 'is-inactive'}`}>
                <div className="er-chCardTop">
                    <h3 className="er-chTitle">{challenge.TitleEN}</h3>
                    <p className="er-chDesc">{challenge.DescriptionEN}</p>

                    {isActive && (
                        <>
                            <div className="er-chActions">
                                <button className="er-chLinkBtn" type="button" onClick={() => setShowPrices(v => !v)}>
                                    {showPrices ? 'Hide prices' : 'Prices'}
                                </button>
                            </div>

                            {showPrices && (
                                <div className="er-priceBox" aria-label="Price list">
                                    <div className="er-priceRow"><span>5 people</span><span>50€</span></div>
                                    <div className="er-priceRow"><span>4 people</span><span>45€</span></div>
                                    <div className="er-priceRow"><span>3 people</span><span>40€</span></div>
                                    <div className="er-priceRow"><span>2 people</span><span>35€</span></div>
                                    <div className="er-priceRow"><span>1 person</span><span>25€</span></div>
                                </div>
                            )}
                        </>
                    )}
                </div>

                <div className="er-chMeta">
                    <div className="er-metaItem" title="Duration">
                        <FontAwesomeIcon icon={faClock} className="er-metaIcon" />
                        <span>{challenge.Duration}</span>
                    </div>
                    <div className="er-metaItem" title="Number of players">
                        <FontAwesomeIcon icon={faUsers} className="er-metaIcon" />
                        <span>{challenge.Participants}</span>
                    </div>
                </div>

                <div className="er-chCardBottom">
                    <LevelDots level={challenge.Level} />

                    {isActive ? (
                        <Link
                            className="er-button er-button-primary er-chCta"
                            to="/bookings"
                            onClick={() => handleClick(challenge.ChallengeId)}
                        >
                            Book
                        </Link>
                    ) : (
                        <button className="er-button er-chCta er-chCta-disabled" type="button" disabled>
                            Book
                        </button>
                    )}
                </div>
            </article>
        );
    };

    return (
        <div className="er-page">
            {/*<SummerBanner></SummerBanner>*/}
            <section className="er-hero" aria-label="Escape Room Bragança">
                <picture className="er-heroMedia">
                    <source media="(max-width: 600px)" srcSet={backgroundImageMobile} />
                    <img src={backgroundImage} alt="" className="er-heroImg" />
                </picture>

                <div className="er-heroOverlay">
                    <div className="er-balloons" aria-hidden="true">
                        <button
                            type="button"
                            className={`er-balloon b1 ${poppedBalloons.b1 ? 'is-popped' : ''}`}
                            aria-label="Balloon"
                            onClick={() => handlePopBalloon('b1')}
                        />
                        <button
                            type="button"
                            className={`er-balloon b2 ${poppedBalloons.b2 ? 'is-popped' : ''}`}
                            aria-label="Balloon"
                            onClick={() => handlePopBalloon('b2')}
                        />
                        <button
                            type="button"
                            className={`er-balloon b3 ${poppedBalloons.b3 ? 'is-popped' : ''}`}
                            aria-label="Balloon"
                            onClick={() => handlePopBalloon('b3')}
                        />
                        <button
                            type="button"
                            className={`er-balloon b4 ${poppedBalloons.b4 ? 'is-popped' : ''}`}
                            aria-label="Balloon"
                            onClick={() => handlePopBalloon('b4')}
                        />
                        <button
                            type="button"
                            className={`er-balloon b5 ${poppedBalloons.b5 ? 'is-popped' : ''}`}
                            aria-label="Balloon"
                            onClick={() => handlePopBalloon('b5')}
                        />
                    </div>
                    <div className="er-container er-heroInner">
                        <div className="er-heroBadge">Our room is 2 years old!</div>

                        <h1 className="er-heroTitle">Escape Room Bragança</h1>
                        <p className="er-heroSubtitle">
                            Two years of stories, mysteries and memories. Bring your team and live an unforgettable challenge.
                        </p>

                        <div className="er-heroFeature">
                            <img src={cardImage} className="er-heroFeatureImg" alt="" />
                            <div className="er-heroFeatureText">
                                <div className="er-heroKicker">Featured</div>
                                <div className="er-heroFeatureTitle">The Time Traveller</div>
                                <div className="er-heroFeatureSub">What mysteries does he hide?</div>
                            </div>
                        </div>

                        <div className="er-heroCtas">
                            <Link className="er-button er-button-primary" to="/bookings" onClick={() => handleClick('3')}>
                                Book now
                            </Link>
                            <a className="er-button er-button-secondary" href="#challenges">
                                View challenges
                            </a>
                        </div>

                        <div className="er-heroChips" aria-label="Highlights">
                            <div className="er-chip">
                                <span className="er-chipTop">City</span>
                                <span className="er-chipBottom">Bragança</span>
                            </div>
                            <div className="er-chip">
                                <span className="er-chipTop">Experience</span>
                                <span className="er-chipBottom">60 min</span>
                            </div>
                            <div className="er-chip">
                                <span className="er-chipTop">Groups</span>
                                <span className="er-chipBottom">1–5 people</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="challenges" className="er-section">
                <div className="er-container">
                    <div className="er-sectionHead">
                        <h2 className="er-sectionTitle">Our challenges</h2>
                        <p className="er-sectionSubtitle">Pick the story. We’ll handle the rest.</p>
                    </div>

                    {isLoading ? (
                        <div className="er-emptyState">Loading challenges…</div>
                    ) : hasError ? (
                        <div className="er-emptyState">
                            We couldn’t load challenges right now. Please try again later.
                        </div>
                    ) : (
                        <div className="er-chGrid">
                            {sortedChallenges.map((challenge) => (
                                <ChallengeCard key={challenge.ChallengeId} challenge={challenge} />
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default Desafios;